import React from 'react';

type Props = {
  value: number;
  size?: number;
  strokeWidth?: number;
  color?: string;
  trackColor?: string;
  glow?: boolean;
};

export default function RingProgress({
  value,
  size = 52,
  strokeWidth = 5,
  color = '#22D3EE',
  trackColor = 'rgba(255,255,255,0.08)',
  glow = true,
}: Props) {
  const r = (size - strokeWidth) / 2;
  const c = 2 * Math.PI * r;
  const clamped = Math.max(0, Math.min(100, value));
  const offset = c - (clamped / 100) * c;
  const glowId = `ring-glow-${color.replace('#', '')}`;

  return (
    <svg width={size} height={size} className="shrink-0 -rotate-90">
      <defs>
        {glow && (
          <filter id={glowId} x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="2" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        )}
      </defs>
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        fill="none"
        stroke={trackColor}
        strokeWidth={strokeWidth}
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeDasharray={c}
        strokeDashoffset={offset}
        filter={glow ? `url(#${glowId})` : undefined}
        className="transition-[stroke-dashoffset] duration-700 ease-out-expo"
      />
    </svg>
  );
}
